import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import * as ROUTES from '../constants/routes';
import { useSignInAuthorization, useAdminAuthorization } from '../hooks';
import { celebrityProfileUrl } from '../helpers';
import Search from './Search';
import Icon from './Icon';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const isSignedIn = useSignInAuthorization(false);
  const isAdmin = useAdminAuthorization(false);
  const [hoveredLink, setHoveredLink] = useState(null);
  const { t } = useTranslation();

  return (
    <header>
      <nav className="navbar bg-secondary" dir="ltr">
        <div className="container d-flex align-items-center">
          <Link
            className="navbar-brand mr-auto mr-lg-0 custom-brand"
            to={ROUTES.HOME}
            style={{ marginLeft: '0.4rem' }}
          >
            {t('nav.brand')}
          </Link>

          <div className="collapse navbar-collapse" id="menu" style={{ paddingLeft: '0.5rem' }}>
            <ul className="navbar-nav">
              <li
                className="nav-item"
                data-toggle="collapse"
                data-target="#menu"
              >
                <Link
                  className="nav-link"
                  to={ROUTES.CELEBRITY_SUGGEST}
                  onMouseEnter={() => setHoveredLink('suggest')}
                  onMouseLeave={() => setHoveredLink(null)}
                  style={{ color: hoveredLink === 'suggest' ? '#FFFFFF' : '#F5F5D1' }}
                >
                  {t('nav.suggestCelebrity')}
                </Link>
              </li>
              <li
                className="nav-item"
                data-toggle="collapse"
                data-target="#menu"
              >
                <Link
                  className="nav-link"
                  to={ROUTES.VOTE}
                  onMouseEnter={() => setHoveredLink('vote')}
                  onMouseLeave={() => setHoveredLink(null)}
                  style={{ color: hoveredLink === 'vote' ? '#FFFFFF' : '#F5F5D1' }}
                >
                  {t('nav.vote')}
                </Link>
              </li>
              <li
                className="nav-item"
                data-toggle="collapse"
                data-target="#menu"
              >
                <Link
                  className="nav-link"
                  to={ROUTES.RATINGS}
                  onMouseEnter={() => setHoveredLink('ratings')}
                  onMouseLeave={() => setHoveredLink(null)}
                  style={{ color: hoveredLink === 'ratings' ? '#FFFFFF' : '#F5F5D1' }}
                >
                  {t('nav.ratings')}
                </Link>
              </li>
              <li
                className="nav-item"
                data-toggle="collapse"
                data-target="#menu"
              >
                <Link
                  className="nav-link"
                  to={ROUTES.BLOG}
                  onMouseEnter={() => setHoveredLink('blog')}
                  onMouseLeave={() => setHoveredLink(null)}
                  style={{ color: hoveredLink === 'blog' ? '#FFFFFF' : '#F5F5D1' }}
                >
                  {t('nav.blog')}
                </Link>
              </li>
            </ul>
            <div className="mx-auto">
              <Search createUrl={celebrityProfileUrl} />
            </div>
            <ul
              className="navbar-nav"
              data-toggle="collapse"
              data-target="#menu"
            >
              {isAdmin && (
                <li
                  className="nav-item"
                  data-toggle="collapse"
                  data-target="#menu"
                >
                  <Link className="nav-link" to={ROUTES.ADMIN}>
                    {t('nav.admin')}
                  </Link>
                </li>
              )}
              {isSignedIn && (
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    id="accountDropdown"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    to="#"
                  >
                    {t('nav.account')}
                  </Link>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="accountDropdown"
                  >
                    <Link
                      className="dropdown-item"
                      to={ROUTES.ACCOUNT_SETTINGS}
                    >
                      {t('nav.settings')}
                    </Link>
                    <Link
                      className="dropdown-item"
                      to={ROUTES.ACCOUNT_FAVORITES}
                    >
                      {t('nav.favorites')}
                    </Link>
                    <Link
                      className="dropdown-item"
                      to={ROUTES.ACCOUNT_MY_SUGGESTIONS}
                    >
                      {t('nav.mySuggestions')}
                    </Link>
                    <Link className="dropdown-item" to={ROUTES.SIGNOUT}>
                      {t('nav.signOut')}
                    </Link>
                  </div>
                </li>
              )}
              {!isSignedIn && (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to={ROUTES.SIGNIN}
                    onMouseEnter={() => setHoveredLink('signin')}
                    onMouseLeave={() => setHoveredLink(null)}
                    style={{ color: hoveredLink === 'signin' ? '#FFFFFF' : '#F5F5D1' }}
                  >
                    {t('nav.signIn')}
                  </Link>
                </li>
              )}
            </ul>
            {!isSignedIn && (
              <Link
                className="btn my-2 my-sm-0"
                to={ROUTES.SIGNUP}
                onMouseEnter={() => setHoveredLink('signup')}
                onMouseLeave={() => setHoveredLink(null)}
                style={{
                  color: hoveredLink === 'signup' ? '#0A2342' : '#F5F5D1',
                  borderColor: '#F5F5D1',
                  backgroundColor: hoveredLink === 'signup' ? '#F5F5D1' : 'transparent'
                }}
              >
                {t('nav.signUp')}
              </Link>
            )}
          </div>

          <div className="d-flex align-items-center ml-auto">
            <button
              className="navbar-toggler mr-2"
              type="button"
              data-toggle="collapse"
              data-target="#menu"
              style={{ outline: 'none', boxShadow: 'none', border: 'none' }}
            >
              <Icon style={{ color: '#F5F5D1' }} icon="bars" fixedWidth />
            </button>
            <LanguageSwitcher className="my-2 my-lg-0" />
          </div>
        </div>
      </nav>
    </header>
  );
}
